import React from 'react';

const Badge = ({ product, currentTab }) => {
  let saleText;
  let newText;
  let twoBadges;
  const salePercent = parseInt(product.sale_percent);
  const inline = currentTab !== 'all';

  if (salePercent > 5) {
    saleText = `${salePercent}% off`;
  }

  if (product.is_new) {
    newText = 'New';
  }

  if (!saleText && !newText) return null;
  if (saleText && newText) twoBadges = true;

  const type = saleText ? 'sale' : 'new';

  // When we only have one badge to show, or when we are on the best-sellers tab
  if (!inline || !twoBadges) {
    return <div className={`badge ${type}${inline ? ' inline' : ''}`}>{saleText || newText}</div>;
  }

  // When we have two badges to show, and are on either 'sale' or 'new' tab
  return (
    <>
      <div className={`badge ${currentTab} inline`}>
        {currentTab === 'sale' ? saleText : newText}
      </div>
      <div className={`badge ${currentTab === 'sale' ? 'new' : 'sale'}`}>
        {currentTab === 'sale' ? newText : saleText}
      </div>
    </>
  );
};

export default Badge;
